module.exports = __webpack_public_path__ + "img/welcome.0936b495.png";